module.exports = __webpack_public_path__ + "static/media/039-Jakes on Main.dfd9b36c.jpg";